import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
export var queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
});
export default (function (_a) {
    var children = _a.children;
    return React.createElement(QueryClientProvider, { client: queryClient }, children);
});
